import { createReducer } from "reduxsauce"
import { forEach, get, omit } from "lodash"
import actionCreator from "helpers/actionCreator"
import { takeLatest, select, put, all } from "redux-saga/effects"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { Types as HistoryTypes } from "../../../actions/app/history"
import { getCategoryItemsSubset } from "./selectors/data"
import { getOnly } from "./selectors"

export const { Types, Creators } = actionCreator("ompnt/modules/securityProfileFactorSensitivity", {
  toggle: {
    props: ["id", "currentState", "factorSensitivityType"],
    track: true,
    trackType: "security-profile-factor-sensitivity-graph-legend-factor",
    trackPayload: ({ id, currentState, factorSensitivityType }) => ({ factor: id, state: currentState ? "on" : "off", factorSensitivityType }),
  },
  focusChartLine: ["focusedChartLine"],
  blurChartLine: [],
  setDisplayType: {
    props: ["displayType", "factorSensitivityType"],
    track: true,
    trackType: "security-profile-factor-sensitivity-category-selection",
    trackPayload: ({ displayType, factorSensitivityType }) => ({ type: displayType, factorSensitivityType }),
  },
  toggleOnly: {
    props: ["id", "state", "factorSensitivityType"],
    track: true,
    trackType: "security-profile-factor-sensitivity-graph-legend-factor",
    trackPayload: ({ id, state, factorSensitivityType }) => ({ factor: id, state, factorSensitivityType }),
  },
  toggleOnlySuccess: ["selected", "only", "items"],
})

const DEFAULT_STATE = {
  displayType: "style",
  focusedChartLine: null,
  disabled: {},
  only: null,
}

function handleSetDisplayType(state, { displayType }) {
  return {
    ...state,
    displayType,
    only: null,
  }
}

function handleToggle(state, { id }) {
  let disabled
  let focusedChartLine

  if (state.disabled[id]) {
    focusedChartLine = id
    disabled = omit(state.disabled, id)
  } else {
    focusedChartLine = null
    disabled = { [id]: true, ...state.disabled }
  }
  return { ...state, disabled, focusedChartLine, only: null }
}

function handleFocusChartLine(state, { focusedChartLine }) {
  return { ...state, focusedChartLine }
}

function handleBlurChartLine(state) {
  return { ...state, focusedChartLine: null }
}

function handleNavigate(state, action) {
  if (get(action, "location.query.security", null)) {
    return { ...state, displayType: "style", focusedChartLine: null }
  } else {
    return state
  }
}

function handleToggleOnlySuccess(state, { selected, only, items }) {
  const disabled = {}
  let focusedChartLine = null
  let onlyDisplay = null

  if (only) {
    focusedChartLine = selected
    onlyDisplay = selected
    forEach(items, ({ id }) => {
      if (id !== selected) {
        disabled[id] = true
      }
    })
  }

  return { ...state, disabled, focusedChartLine, only: onlyDisplay }
}

function handleSetModel(state) {
  return { ...state, only: null, focusedChartLine: null }
}

export default createReducer(DEFAULT_STATE, {
  [Types.TOGGLE]: handleToggle,
  [Types.FOCUS_CHART_LINE]: handleFocusChartLine,
  [Types.BLUR_CHART_LINE]: handleBlurChartLine,
  [Types.SET_DISPLAY_TYPE]: handleSetDisplayType,
  [HistoryTypes.NAVIGATE]: handleNavigate,
  [Types.TOGGLE_ONLY_SUCCESS]: handleToggleOnlySuccess,
  [BaseTypes.SET_MODEL]: handleSetModel,
})

function* handleToggleOnly({ id }) {
  const [items, only] = yield all([
    select(getCategoryItemsSubset),
    select(getOnly),
  ])

  yield put(Creators.toggleOnlySuccess(id, only !== id, items))
}

export function* saga() {
  yield takeLatest(Types.TOGGLE_ONLY, handleToggleOnly)
}
